import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ChatContextData, Room, User, Message } from '../interfaces/interfaces';


const ChatContext = createContext<ChatContextData | undefined>(undefined);

export const useChat = () => {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChat must be used within a ChatProvider');
    }
    return context;
};

export const ChatProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [rooms, setRooms] = useState<Array<Room>>([]); // Initialize with the appropriate data
    const [openChatModal, setOpenChatModal] = useState<boolean>(false);
    const [user, setUser] = useState<User | null>(null);
    const [chatSocket, setChatSocket] = useState<WebSocket | null>(null);
    const [roomSocket, setRoomSocket] = useState<WebSocket | null>(null);
    const [mode, setMode] = useState<string | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [theme, setTheme] = useState<string>("light");
    const [unread, setUnread] = useState<number>(0);
    const [unreadList, setUnreadList] = useState<any[]>([]);
    const [replyMessage, setReplyMessage] = useState<Message | null>(null);
    const [loadingOpenRoom, setLoadingOpenRoom] = useState<boolean>(false);

    const chatContextData: ChatContextData = {
        user,
        setUser,
        rooms,
        setRooms,
        openChatModal,
        setOpenChatModal,
        chatSocket,
        setChatSocket,
        roomSocket,
        setRoomSocket,
        mode,
        setMode,
        token,
        setToken,
        theme,
        setTheme,
        unreadList,
        setUnreadList,
        unread,
        setUnread,
        replyMessage,
        setReplyMessage,
        loadingOpenRoom,
        setLoadingOpenRoom,
    };

    return <ChatContext.Provider value={chatContextData}>{children}</ChatContext.Provider>;
};
